import { api } from "@/api";
import type { CurrentAcuityScoreResponse, UUID } from "@/core/types";

export async function getCurrentAcuityScore(patientId: UUID): Promise<CurrentAcuityScoreResponse> {
  return api.acuityTyped.get_current_acuity_score({
    params: { showLoader: false },
    patientId,
  });
}
